export const CAUSED_BY_FRONT = 'Caused by Frontend';
export const CAUSED_BY_BACK = 'Caused by Back';
export const CAUSED_BY_CORS = 'Caused by CORS';
export const CAUSED_BY_TIMEOUT = '504 Timeout';
export const ERROR_CORS = 'Network Error';

export const TIME_LIMIT = 29;

export const LOGS_UPDATE = 'LOGS_UPDATE';
export const SET_STEP_LOGS = 'SET_STEP_LOGS';
export const LOGS_CONFIG = 'LOGS_CONFIG';
export const SET_SUCCESS_LOGS = 'SET_SUCCESS_LOGS';
export const SET_ERROR_LOGS = 'SET_ERROR_LOGS';
export const SET_LOAD_AUDITORY = 'SET_LOAD_AUDITORY';
export const SET_ID_AUDITORY = 'SET_ID_AUDITORY';
export const CLEAR_AUDITORY = 'CLEAR_AUDITORY';

export const URL_AUDITORY = '/registro/auditoria';
export const apinameUtilitarios = 'UTILITARIOS';

export const GENERIC_MESSAGE_ERROR = [
  'Script error.',
  'frameWrapper',
  "Cannot read properties of undefined (reading 'frameWrapper')"
];
